import { render } from "./AddAccount.vue?vue&type=template&id=561edcc2&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"

import "./AddAccount.vue?vue&type=style&index=0&id=561edcc2&scoped=true&lang=less"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561edcc2"]])

export default __exports__